/**
 * Clients page
 *
 */

'use strict'

var App = require('app')

/* Views */
var ClientsList = require('./list')
var ClientShow = require('./show')
var EditNew = require('./edit_new')

var PageClients = function () {
  /* Routes ----------------------------------------------------------------- */
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      'clients': 'listClients',
      'client/:id': 'showClient'
    },
    allowedRoles: {
      'clients': ['super', 'admin'],
      'client/:id': ['super', 'admin']
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    listClients: function () {
      new ClientsList()
    },
    editNewClient: function (options) {
      new EditNew(options)
    },
    showClient: function (id, client) {
      new ClientShow({
        id: id,
        client: client
      })
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('clients:list', function (options) {
    API.listClients()
  })

  App.globalChannel.on('client:new', function (options) {
    API.editNewClient(options)
  })

  App.globalChannel.on('client:edit', function (options) {
    API.editNewClient(options)
  })

  App.globalChannel.on('client:show', function (options) {
    App.globalChannel.trigger('app:navigate', 'client/' + options.model.id)
    API.showClient(options.model.id, options.model)
  })

  new Router({ controller: API })
}

module.exports = PageClients



// WEBPACK FOOTER //
// ./js/modules/page-clients/index.js